module.exports = __webpack_public_path__ + "img/Faucet Icon.2c88f37a.svg";